module.exports = __webpack_public_path__ + "static/media/ysjp1@2x.d788952b.png";